import { SxProps, Theme } from '@mui/material';
import { MEDIUM_GRAY } from '../../styles/GlobalStyles';
import {
  CARD_SCROLLBAR_THUMB_HEIGHT_PX,
  CARD_SCROLLBAR_WIDTH_PX,
} from './CardListScrollbar.constants';

export const cardListScrollbarStyles = {
  hiddenNativeScrollbar: () =>
    ({
      scrollbarWidth: 'thin',
      scrollbarColor: 'transparent transparent',
      '&::-webkit-scrollbar': {
        width: `${CARD_SCROLLBAR_WIDTH_PX}px`,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: `${CARD_SCROLLBAR_WIDTH_PX}px`,
        backgroundColor: 'transparent',
        backgroundImage: 'none',
      },
    }) as SxProps<Theme>,

  fixedScrollbarThumb: (_theme: Theme, top: number, isVisible: boolean) =>
    ({
      display: isVisible ? 'block' : 'none',
      position: 'absolute',
      top: `${top}px`,
      right: 0,
      width: `${CARD_SCROLLBAR_WIDTH_PX}px`,
      height: `${CARD_SCROLLBAR_THUMB_HEIGHT_PX}px`,
      borderRadius: `${CARD_SCROLLBAR_WIDTH_PX}px`,
      backgroundColor: MEDIUM_GRAY,
      pointerEvents: 'none',
    }) as SxProps<Theme>,
};

export default cardListScrollbarStyles;
